import TariffTypes from '../TariffTypes';
/**
 * Filters for the Tariffs list. All client-side — values are consumed by
 * an in-memory filter pass over the store's tariffs (see Tariffs.tsx),
 * so `toApiParam` is intentionally omitted from every config.
 */
export function makeTariffsFilters({ markets }) {
    return [
        {
            id: 'name',
            label: 'Name',
            kind: 'text',
            initialValue: null,
            placeholder: 'Search by name…',
        },
        {
            id: 'type',
            label: 'Type',
            kind: 'select-multi',
            initialValue: [],
            options: TariffTypes.map((tt) => ({ label: tt.name, value: tt.value })),
        },
        {
            id: 'markets',
            label: 'Markets',
            kind: 'select-multi',
            initialValue: [],
            options: markets.map((m) => ({ label: m, value: m })),
        },
        {
            id: 'is_default',
            label: 'Default Only',
            kind: 'toggle',
            initialValue: false,
        },
    ];
}
